module.exports = __webpack_public_path__ + "img/cert-djc.670768f1.png";